import { render } from "./instantpay-automation.vue?vue&type=template&id=99c1cee0"
import script from "./instantpay-automation.vue?vue&type=script&lang=js"
export * from "./instantpay-automation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__